import { useReducer } from 'react';

// api

import { api, replaceParamsInStr } from '../../common-utils-services/axiosUtil';
import endpoints from '../../../constants/configs/endpoints';

// endpoints

const SEARCH_AGENTS_FOR_DEV_ENV = '/mocks/agents/agent-listing.json';
const SEARCH_AGENTS_ERROR_FOR_DEV_ENV = '/mocks/agents/agents-search-error.json';
const SEARCH_AGENTS_NO_RESULTS_FOR_DEV_ENV = '/mocks/agents/agents-search-no-results.json';
// const SEARCH_AGENTS_NAME_PAGINATE_FOR_DEV_ENV = '/mocks/agents/agent-listing-name-paginate.json';
// const SEARCH_AGENTS_ZIP_PAGINATE_FOR_DEV_ENV = '/mocks/agents/agent-listing-zip-paginate.json';


const actions = {
    SEARCH_AGENTS: 'SEARCH_AGENTS',
    SEARCH_AGENTS_ERROR: 'SEARCH_AGENTS_ERROR'
};

export interface AgentResultDetails {
    brokerId: string;
    websiteUrl: string;
    profilePhotoUrl: string;
    clientsServed: string;
    businessName: string;
    contactNumber: string;
    yourPublicEmail: string;
    distance: number;
    licenseNumber: string;
    productExpertise: string;
    languagesSpoken: string;
    firstName: string;
    lastName: string;
    location: {
        id: number;
        address1: string;
        address2?: string;
        state: string;
        city: string;
        zip: string;
    }
}
export interface AgentListSearchResults {
    statusCode: number;
    status: string;
    message: string | null;
    payload: {
        pageable: {
            pageNumber: number;
            pageSize: number;
            totalPages: number;
            totalElements: number;
            last: boolean;
            first: boolean;
        },
        content: AgentResultDetails[]
    }
    
};

export interface SearchByLocationProps {
    zipcode: string,
    distance: number,
    languagesSpoken: any,
    formName: FormNames
};

export type FormNames = 'searchByLocation' | 'searchByName';

export interface SearchByNameProps {
    firstName: string,
    lastName: string,
    companyName: string,
    formName: FormNames
};

type Action =
  | { type: 'SEARCH_AGENTS', payload: AgentListSearchResults | undefined }
  | { type: 'SEARCH_AGENTS_ERROR', payload: string | null }

function reducer(state, action: Action) {
    switch (action.type) {
        case actions.SEARCH_AGENTS:
            return {
                ...state,
                data: action.payload,
                isError: false
            };
        case actions.SEARCH_AGENTS_ERROR:
          return {
              ...state,
              data: null,
              errorMessage: action.payload,
              isError: true
          };
        default:
            return state;
    }
}

const initialState: AgentListSearchResults | undefined = undefined;
export default () => {
    const [data, dispatch]  = useReducer(reducer, initialState);

    const searchAgentListingByLocation = async (pageNumber: number, inputData: SearchByLocationProps) => {
        try {
            const { zipcode, distance, languagesSpoken } = inputData;
            const url = global.__ENV__.PRODUCTION ? endpoints.AGENTS_SEARCH_BY_ZIP : SEARCH_AGENTS_FOR_DEV_ENV;
            const languagesAsString = languagesSpoken.map(function(item) {
                return item['value'];
            });
            const endpoint = replaceParamsInStr(url, {
                pageNumber: !!pageNumber || 0,
                zipcode: zipcode || '',
                distance: distance || '',
                languagesSpoken: languagesAsString || ''
            });

            const res = await api.get<AgentListSearchResults>(endpoint);
            if (res?.data?.statusCode === 200 && res?.data?.payload?.content) {
                dispatch({ type: 'SEARCH_AGENTS', payload: res.data });
            } else {
                console.log(`In useAgentListing: searchAgentListingByLocation(): Request to (${endpoint}) was NOT successful: error esponse = `, res.data.message);
                dispatch({ type: 'SEARCH_AGENTS_ERROR', payload: res.data.message });
            }

        } catch (e) {
            console.log(`In useAgentListing: searchAgentListingByLocation(): Request to (${endpoints.AGENTS_SEARCH_BY_ZIP}) failed with error = `, e);
            dispatch({ type: 'SEARCH_AGENTS_ERROR', payload: e.message });
        }
    };

    const searchAgentListingByName = async (pageNumber: number, inputData: SearchByNameProps) => {
        try {
            const { firstName, lastName, companyName } = inputData;
            const url = global.__ENV__.PRODUCTION ? endpoints.AGENTS_SEARCH_BY_NAME : SEARCH_AGENTS_FOR_DEV_ENV;
            const endpoint = replaceParamsInStr(url, {
                pageNumber: !!pageNumber || 0,
                firstName: firstName || '',
                lastName: lastName || '',
                companyName: companyName || ''
            });
            const res = await api.get<AgentListSearchResults>(endpoint);
            // console.log(`In useAgentListing: searchAgentListingByName(): Request to (${endpoint}) was successful with response = `, res.data);
            if (res?.data?.statusCode === 200 && res?.data?.payload?.content) {
                dispatch({ type: 'SEARCH_AGENTS', payload: res.data });
            } else {
                console.log(`In useAgentListing: searchAgentListingByName(): Request to (${endpoint}) was NOT successful: error esponse = `, res.data.message);
                dispatch({ type: 'SEARCH_AGENTS_ERROR', payload: res.data.message });
            }
        } catch (e) {
            console.log(`In useAgentListing: searchAgentListingByName(): Request to (${endpoints.AGENTS_SEARCH_BY_NAME}) failed with error = `, e);
            dispatch({ type: 'SEARCH_AGENTS_ERROR', payload: e.message });
        }
    };

    return {
        ...data,
        searchAgentListingByLocation: (pageNumber: number, inputData: SearchByLocationProps) => {
            searchAgentListingByLocation(pageNumber, inputData);
        },
        searchAgentListingByName: (pageNumber: number, inputData: SearchByNameProps) => {
            searchAgentListingByName(pageNumber, inputData);
        }
    };
};